import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertModal } from '@lili/lili-frontend-common';

import useStore from '../../../../store';
import { TeamMember } from '../../../../types';

interface RemoveTeamMemberModalProps {
  teamMemberToDelete: TeamMember;
  isLoading: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const RemoveTeamMemberModal = ({
  teamMemberToDelete,
  isLoading,
  onCancel,
  onSubmit,
}: RemoveTeamMemberModalProps) => {
  const { t } = useTranslation();
  const summary = useStore((state) => state.summary);
  const authorizedUserId = summary.authorizedUserData?.externalId;
  const isCurrentUser = authorizedUserId === teamMemberToDelete.externalId;
  const userName = `${
    teamMemberToDelete.lastName && teamMemberToDelete.firstName
      ? `${teamMemberToDelete.firstName} ${teamMemberToDelete.lastName}`
      : teamMemberToDelete.email
  }`;
  return (
    <AlertModal
      title={
        isCurrentUser
          ? t('ACCOUNT_SETTINGS.TEAM.REMOVE_MODAL.CURRENT_USER_TITLE')
          : t('ACCOUNT_SETTINGS.TEAM.REMOVE_MODAL.TITLE', { userName: `${userName}` })
      }
      isLoading={isLoading}
      description={
        isCurrentUser
          ? t('ACCOUNT_SETTINGS.TEAM.REMOVE_MODAL.CURRENT_USER_SUBTITLE')
          : t('ACCOUNT_SETTINGS.TEAM.REMOVE_MODAL.SUBTITLE')
      }
      submitButtonTitle={t('ACCOUNT_SETTINGS.TEAM.REMOVE_MODAL.REMOVE_BUTTON')}
      cancelButtonTitle={t('ACCOUNT_SETTINGS.TEAM.REMOVE_MODAL.CANCEL_BUTTON')}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  );
};
